'use strict';
module.exports = {
  /*服务器登录验证地址*/
  server_api: '/api/'

};
